import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useConfig } from "../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../utils/AxiosInstance.jsx";

const ResetPassword = () => {

    const { API_BASE_URL } = useConfig();
    const AxiosInstance = createAxiosInstance(API_BASE_URL);


    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");
    const email = searchParams.get("email");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!token || !email) {
            setError("Invalid or expired reset link.");
            return;
        }

        if (password.length < 6) {
            setError("Password must be at least 6 characters.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            setLoading(true);

            await AxiosInstance.post("/reset-password", {
                email,
                token,
                password,
                password_confirmation: confirmPassword,
            });

            alert("Password reset successful. Please login.");
            navigate("/");
        } catch (err) {
            setError(
                err.response?.data?.message ||
                "Reset link is invalid or expired."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="auth forgot-password-page bg-base d-flex flex-wrap">
            {/* Left Image */}
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="assets/images/auth/auth-img.png" alt="auth" />
                </div>
            </div>

            {/* Right Form */}
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div className="mb-24">
                        <Link to="/" style={{ width: "75px" }}>
                            <img src="assets/images/logo.webp" alt="logo" />
                        </Link>
                        <h4 className="mt-12">Reset Password</h4>
                        <p className="text-secondary-light text-sm">
                            Enter your new password below
                        </p>
                    </div>

                    {error && (
                        <div className="alert alert-danger text-sm">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="position-relative mb-3">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="New Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <span
                                className="position-absolute top-50 translate-middle-y cursor-pointer"
                                style={{ right: "12px" }}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <Icon
                                    icon={
                                        showPassword
                                            ? "mage:eye"
                                            : "mage:eye-off"
                                    }
                                />
                            </span>
                        </div>

                        <div className="position-relative mb-3">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="Confirm New Password"
                                    value={confirmPassword}
                                    onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                    }
                                    required
                                />
                            </div>
                            <span
                                className="position-absolute top-50 translate-middle-y cursor-pointer"
                                style={{ right: "12px" }}
                                onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                }
                            >
                                <Icon
                                    icon={
                                        showConfirmPassword
                                            ? "mage:eye"
                                            : "mage:eye-off"
                                    }
                                />
                            </span>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary text-sm px-12 py-16 w-100 radius-12 mt-16"
                            disabled={loading}
                        >
                            {loading ? "Resetting..." : "Reset Password"}
                        </button>

                        <div className="text-center mt-24">
                            <Link to="/" className="text-primary-600 fw-bold">
                                Back to Sign In
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ResetPassword;
